import { FirebaseApp } from 'firebase/app';
import { getMessaging, getToken, Messaging, onMessage } from 'firebase/messaging';
import { getNotificationDisplayData } from './util';

export let FCMToken: string;
let messaging: Messaging;

export const initMessaging = (app: FirebaseApp) => {
    if ('serviceWorker' in navigator) {
        console.log('[messaging.ts] initializing messaging');
        messaging = getMessaging(app);
        onMessage(messaging, async (payload) => {
            await handleNotification(payload);
        });
    }
};

export const GetPermission = async (callback: any) => {
    if (navigator)
        Notification.requestPermission().then(async (permission) => {
            if (permission === 'granted') {
                const registration = await navigator.serviceWorker.getRegistration(
                    'service-worker.js',
                );

                const ready = await navigator.serviceWorker.ready;

                if (!!registration && !!ready) {
                    getToken(messaging, {
                        vapidKey: process.env.REACT_APP_FIREBASE_VAPIDKEY,
                        serviceWorkerRegistration: registration,
                    })
                        .then(
                            (value) => {
                                console.log('[messaging.ts] got token: ' + value);
                                FCMToken = value;
                                callback(value);
                                return value;
                            },

                            (reason) => {
                                console.log('[messaging.ts] failed with reason: ' + reason);
                                return null;
                            },
                        )
                        .catch((error) => {
                            console.log('[messaging.ts] error: ' + error);
                        });
                }
            }
        });
};

const handleNotification = async (payload: any) => {
    console.log('[messaging.ts] message received in foreground');

    if (Notification.permission === 'denied') {
        alert('User has blocked push notification.');
        return;
    }

    if (!('PushManager' in window)) {
        console.log('[messaging.ts] this browser doesnt support push notifications');
        return;
    }

    if (!payload?.data?.StreamSixID) {
        console.log('[messaging.ts] userID was null');
        return;
    }

    if (!payload?.data?.LicenseID) {
        console.log('[messaging.ts] License was null');
        return;
    }

    const displayData = await getNotificationDisplayData(
        payload.data.StreamSixID,
        payload.data.LicenseID,
    );

    const notificationOptions: NotificationOptions = {
        body: displayData.body,
        icon: displayData.icon,
        data: displayData.data,
    };

    navigator?.serviceWorker?.ready?.then((serviceWorker) => {
        if (serviceWorker) {
            serviceWorker.showNotification(displayData.title, notificationOptions);
        }
    });
};
